import { Card } from "@finway-group/shared/lib/models"
import { ModelId } from "@finway-group/shared/lib/models/modelId/modelId.interface"
import React from "react"
import { useTranslation } from "react-i18next"
import { generatePath, Link } from "react-router-dom"

import { RoutePathEnum } from "Shared/router/RoutePath.enum"

interface CreditCardLinkProps {
    card: Pick<Card, "last4Digits"> & ModelId
}

export const CreditCardLink = ({ card }: CreditCardLinkProps) => {
    const { t } = useTranslation()

    if (!card) {
        return null
    }

    return (
        <li>
            <span className="title">{t("label:attached_card")}</span>
            <span className="text truncate max-w-300">
                <Link to={generatePath(RoutePathEnum.CARD_DETAIL_PAGE, { id: card._id })}>{`**** **** **** ${card?.last4Digits}`}</Link>
            </span>
        </li>
    )
}
